import { useQuery } from "@tanstack/react-query";
import {
	EnrollmentSummaryConfigurableFilters,
	EnrollmentSummaryConfigurableResponse,
	reportsService,
} from "../../services/reports.service";

// SIMS-6960 — Enrollment Summary (configurable events). Re-fetches on any
// filter/page change (all in the queryKey); disabled until a program is
// selected (the report does not render without one).
const useEnrollmentSummaryConfigurable = (
	filters: EnrollmentSummaryConfigurableFilters,
) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<EnrollmentSummaryConfigurableResponse>({
		queryKey: [
			"reports-enrollment-summary-configurable",
			filters.accountId,
			filters.programId,
			filters.status ?? "",
			filters.orgUnitId ?? "",
			filters.providerId ?? "",
			filters.pageNumber ?? 0,
			filters.pageSize ?? 25,
		],
		queryFn: () => reportsService.getEnrollmentSummaryConfigurable(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useEnrollmentSummaryConfigurable;
